const bookingHoursAuthActions = new Set([
    'wl_get_bookings_cloud_auth',
    'wl_get_create_booking_cloud_auth',
    'wl_get_booking_period_popup_cloud_auth',
]);

function getCloudAuthSessionStorage() {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return window.sessionStorage || null;
    } catch (error) {
        return null;
    }
}

function buildCloudAuthStorageKey({bootstrapAction = '', postId = 0, nonce = '', contextKey = ''} = {}) {
    const normalizedAction = String(bootstrapAction || '').trim();
    const normalizedPostId = Number.parseInt(postId, 10) || 0;
    const normalizedNonce = String(nonce || '').trim();
    const normalizedContextKey = String(contextKey || '').trim();

    // Refetch booking hours claims after reload instead of reusing the old
    // personal-hours policy for the token's remaining lifetime (up to 10 hours).
    const namespace = bookingHoursAuthActions.has(normalizedAction) ? 'wl_cloud_auth:booking-hours-v2' : 'wl_cloud_auth';
    return `${namespace}:${normalizedAction}:${normalizedPostId}:${normalizedNonce}:${normalizedContextKey}`;
}

export function readCloudAuthFromSession({
    bootstrapAction = '',
    postId = 0,
    nonce = '',
    contextKey = '',
    normalizeAuthPayload = null,
} = {}) {
    const storage = getCloudAuthSessionStorage();
    if (!storage || typeof normalizeAuthPayload !== 'function') {
        return null;
    }

    const storageKey = buildCloudAuthStorageKey({
        bootstrapAction,
        postId,
        nonce,
        contextKey,
    });
    const rawPayload = storage.getItem(storageKey);
    if (!rawPayload) {
        return null;
    }

    try {
        const storedPayload = JSON.parse(rawPayload);
        const normalizedPayload = normalizeAuthPayload(storedPayload);
        if (!normalizedPayload) {
            storage.removeItem(storageKey);
            return null;
        }

        return normalizedPayload;
    } catch (error) {
        storage.removeItem(storageKey);
        return null;
    }
}

export function writeCloudAuthToSession({
    bootstrapAction = '',
    postId = 0,
    nonce = '',
    contextKey = '',
    authPayload = null,
    normalizeAuthPayload = null,
} = {}) {
    const storage = getCloudAuthSessionStorage();
    if (!storage) {
        return;
    }

    const storageKey = buildCloudAuthStorageKey({
        bootstrapAction,
        postId,
        nonce,
        contextKey,
    });

    if (typeof normalizeAuthPayload !== 'function') {
        storage.removeItem(storageKey);
        return;
    }

    const normalizedPayload = normalizeAuthPayload(authPayload);
    if (!normalizedPayload) {
        storage.removeItem(storageKey);
        return;
    }

    try {
        storage.setItem(storageKey, JSON.stringify(normalizedPayload));
    } catch (error) {
        storage.removeItem(storageKey);
    }
}

export function clearCloudAuthFromSession({
    bootstrapAction = '',
    postId = 0,
    nonce = '',
    contextKey = '',
} = {}) {
    const storage = getCloudAuthSessionStorage();
    if (!storage) {
        return;
    }

    const storageKey = buildCloudAuthStorageKey({
        bootstrapAction,
        postId,
        nonce,
        contextKey,
    });
    storage.removeItem(storageKey);
}
